// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-PhotoContainer-module--cls1--2ACCP","cls2":"styles-PhotoContainer-module--cls2--30sAf styles-PhotoContainer-module--cls1--2ACCP"};